<template>
  <a-drawer
:maskClosable="false"
width="60%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-descriptions :column="4" title="" class="full-width-descriptions">
      <a-descriptions-item label="广告所属"> {{ form.typeName }} </a-descriptions-item>
      <a-descriptions-item label="简介说明">
        {{ form.overviewVal }}
      </a-descriptions-item>
      <a-descriptions-item label="跳转类型">
        <!-- {{ form.openType }} -->
        {{ form.openType == 0 ? '无动作' : form.openType == 1 ? '跳内文本' : '跳外部地址' }}
      </a-descriptions-item>
      <a-descriptions-item label="外部地址" v-if="form.openType == 2">
        {{ form.dataUrl }}
      </a-descriptions-item>
      <a-descriptions-item label="开始时间">
        {{ form.startTime }}
      </a-descriptions-item>
      <a-descriptions-item label="结束时间">
        {{ form.endTime }}
      </a-descriptions-item>
      <a-descriptions-item label="审核状态">
        {{ form.auditingState == 0 ? '审核中' : form.auditingState == 1 ? '审核通过' : '审核未通过' }}
      </a-descriptions-item>
      <a-descriptions-item label="审核人员" v-if="form.auditingState !== 0">
        {{ form.auditingUserName }}
      </a-descriptions-item>
      <a-descriptions-item label="审核时间" v-if="form.auditingState !== 0">
        {{ form.auditingVal }}
      </a-descriptions-item>
      <a-descriptions-item label="审核说明" v-if="form.auditingState !== 0">
        {{ form.auditingVal }}
      </a-descriptions-item>
      <a-descriptions-item label="上架状态">
        {{ form.upState == 0 ? '下架' : '上架' }}
      </a-descriptions-item>
      <a-descriptions-item label="下架人员" v-if="form.dowUserName">
        {{ form.dowUserName }}
      </a-descriptions-item>
      <a-descriptions-item label="上架时间" v-if="form.dowTime">
        {{ form.dowTime }}
      </a-descriptions-item>
      <a-descriptions-item label="图片">
        <div v-viewer>
          <img
            @error="
              (e) => {
                e.target.src = errorImage
              }
            "
            :src="$url + form.fileUrl"
            alt=""
            v-if="form.fileUrl"
          />
        </div>
      </a-descriptions-item>
    </a-descriptions>
    <div v-if="form.openType == 1">
      详情文本
      <div v-html="form.detailsText" v-if="form.openType == 1"></div>
    </div>
  </a-drawer>
</template>
<script>
import { getObj } from '@/api/pressure/carousel'
export default {
  name: 'Detail',
  data() {
    return {
      submitLoading: false,
      // 表单参数
      form: {},
      open: false,
      isShow: false,
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
      this.formTitle = '添加轮播'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      const postId = row ? row.id : ids
      console.log(postId, 'postIdpostId')

      getObj(postId).then((response) => {
        console.log(response.data.openType, 'responseresponse')

        this.form = response.data
        this.open = true
        this.formTitle = '详情'
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
img {
  width: 50px;
  height: 50px;
}
</style>
